<template>
  <div class="regional-agent">
    <div class="banner">
      <h1 class="title">点滴灵犀智能语音陪伴玩偶--关爱与健康相伴</h1>
      <div class="banner-image">
        <img src="@/assets/regionalAgent/0.png" alt="智能语音陪伴玩偶">
      </div>
      <p class="intro-text">"你好，我是小犀"，欢迎来到点滴灵犀，我们将科技与温情完美结合。新品AI小犀是一款专为特定人群设计的智能语音陪伴玩偶，旨在通过语音互动、情感交流以及专业心理健康导来促进各个年龄段人群的心理健康状况。</p>
    </div>

    <div class="features">
      <h2 class="section-title">产品亮点</h2>
      <div class="feature-cards">
        <div class="feature-card">
          <h3>声音定制</h3>
          <img src="@/assets/regionalAgent/card1.jpg" alt="声音定制">
          <p>利用先进的人工智能技术，AI小犀能够智能解析好友的声音，使互动更加亲密和情感化。</p>
        </div>
        <div class="feature-card">
          <h3>情绪识别</h3>
          <img src="@/assets/regionalAgent/card2.jpg" alt="情绪识别">
          <p>不仅能识别情绪，还能根据个人需求给予贴心的情绪疏导。</p>
        </div>
        <div class="feature-card">
          <h3>心理疏导</h3>
          <img src="@/assets/regionalAgent/card3.jpg" alt="心理疏导">
          <p>内置心理健康基础大数据，可以提供心理健康的初步支持，可有助于预防如阿尔茨海默症等疾病的发生和发展。</p>
        </div>
      </div>
    </div>
    <div class="features">
      <h2 class="section-title">加入我们</h2>
      <div class="feature-cards" style="margin-top: 60px;">
        <div class="feature-card">
          <img src="@/assets/regionalAgent/card4.jpg" alt="">
          <p>无论您是新手还是经验丰富的创业者，我们都提供了适合的合作模式。</p>
        </div>
        <div class="feature-card">
          <img src="@/assets/regionalAgent/card5.jpg" alt="">
          <p>只需填写简单的信息，提交必要的材料，即可开启这段令人兴奋的合作旅程。</p>
        </div>
        <div class="feature-card">
          <img src="@/assets/regionalAgent/card6.jpg" alt="">
          <p>作为我们的合作伙伴，您不仅可以享受独家的产品折扣，还可以获得全面的支持服务，包括市场营销支持和专业的培训课程。</p>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="contact">
      <h3 class="title">加入我们</h3>
      <p>计划成为点滴灵犀AI小犀的合作伙伴，请下载下方申请表，填写完成后保存为PDF文件上传。一旦收到您的申请，我们将迅速进行审核，并通过电子邮件向您反馈结果。</p>
      <a 
        class="down" 
        href="https://file.lingximind.com/demo/tp/2506/%E7%82%B9%E6%BB%B4%E7%81%B5%E7%8A%80AI%E5%B0%8F%E7%8A%80%E8%AF%AD%E9%9F%B3%E9%99%AA%E6%8A%A4%E7%8E%A9%E5%81%B6%E5%8C%BA%E5%9F%9F%E4%BB%A3%E7%90%86%E7%94%B3%E8%AF%B7%E8%A1%A8.docx"
        download
      >点滴灵犀AI小犀语音陪护玩偶区域代理申请表</a>
      <div class="form">
        <div class="name">
          <span><i>*</i>联系人</span>
          <el-input v-model="username" placeholder="请输入联系人姓名" />
        </div>
        <div class="name">
          <span><i>*</i>联系方式</span>
          <el-input v-model="phone" placeholder="请输入联系人手机号" />
        </div>
        <div class="name">
          <span><i>*</i>申请文件</span>
          <el-input v-model="applyFile" disabled></el-input>
          <file-upload
            class="uploading"
            :limitSize="2"
            v-model:fileList="fileList"
            :limitNumber="1"
            @getFileList="getFileList"
            :listType="'text'"
            :accept="accept"
          ></file-upload>
        </div>
        <div class="submitBtn" @click="submitInfo()">提交</div>
      </div>
    </div>
     
    
  </div>
</template>

<script>
import fileUpload from "./../components/pdfUpload.vue";
import { ElMessage } from 'element-plus'

export default {
  name: 'RegionalAgent',
  components: {
    fileUpload
  },
  data() {
    return {
      username: '',
      phone: '',
      applyFile: '',
      // 上传文件相关
      accept: "application/pdf",
      fileList: [],
    }
  },
  methods: {
    getFileList(arr) {
      if (arr && arr.length > 0) {
        this.fileList = [...arr];
        this.applyFile = arr[0].url;
      }
    },
    submitInfo() {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (this.username == "") {
        ElMessage.error("请输入联系人");
      } else if (this.phone == "" || this.phone.length != 11 || !phoneReg.test(this.phone)) {
        ElMessage.error("请输入正确格式的联系方式");
      } 
      else if (!this.fileList.length) {
        ElMessage.error("请上传申请文件");
      } else {
        let formData = new FormData();
        //此处需要和后端接收的参数名相同
        const payload = {
          username: this.username,
          phone: this.phone,
          applyFile: this.applyFile,
        };
        this.$axios.post(
            //后端接口，自行修改
            // "https://demo.lingximind.com/ew_api/gwChannelMerchants/add",
            "https://lingximind.com/ew_api/gwChannelMerchants/add",
            payload,
            {
              headers: { "Content-Type": "application/json" },
            }
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.username = '',
              this.phone = '',
              this.applyFile = '',
              ElMessage.success("提交成功");
            }
          }).catch((err) => {
            console.error("请求出错", err);
            ElMessage.error("提交失败，请稍后重试");
          });
      }
    }
  }
}
</script>

<style lang="less" scoped>
.regional-agent {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  .banner {
    text-align: center;
    margin-bottom: 60px;

    .title {
      font-size: 30px;
      line-height: 49px;
      font-weight: 400;
      margin-bottom: 35px;
      color: #011739;
    }

    .banner-image {
      width: 100%;
      max-width: 1180px;
      text-align: center;
      margin: 0 auto 20px;
      
      img {
        width: 100%;
        height: auto;
        border-radius: 8px;
      }
    }

    .intro-text {
      font-size: 16px;
      line-height: 1.8;
      color: #666;
      max-width: 800px;
      margin: 0 auto;
    }
  }

  .features {
    padding: 0 80px;
    margin-bottom: 60px;
    .section-title {
      font-size: 30px;
      font-weight: bold;
      // text-align: center;
      margin-left: -80px;
      margin-bottom: 30px;
      color: #011739;
    }

    .feature-cards {
      display: flex;
      justify-content: space-between;
      gap: 110px;
      flex-wrap: wrap;

      .feature-card {
        flex: 1;
        min-width: 250px;
        text-align: center;
        // padding: 20px;
        border-radius: 12px;
        // transition: all 0.3s ease;

        // &:hover {
        //   transform: translateY(-5px);
        //   box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        // }

        img {
          width: 100%;
          height: auto;
          border-radius: 8px;
          box-shadow: 10px 10px 20px rgba(0,0,0,0.2);
        }

        h3 {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 15px;
          color: #333;
        }

        p {
          font-size: 14px;
          line-height: 1.6;
          color: #666;
        }
      }
    }
  }

  .contact {
    h3 {
      font-size: 30px;
      text-align: left;
      margin: 0 0 25px;
      color: #011739;
      font-weight: 700;
    }
    p {
      margin: 0;
      color: rgba(0,0,0,1);
      font-size: 14px;
        }
    .down {
      margin: 25px 0;
      color: rgba(68,142,248,1);
      font-size: 14px;
      text-align: left;
      display: block;
    }
    .form {
      margin: 0;
      // margin: 40px auto 0;
      width: 450px;
      div.name {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        position: relative;
        span {
          display: inline-block;
          height: 40px;
          width: 87px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          color: #434d53;
          font-size: 14px;
          i {
            font-style: normal;
            color: #fe4141;
            font-size: 16px;
            margin-right: 6px;
          }
        }
        .el-input,
        .el-select,
        .el-select .el-input.el-input--suffix {
          flex: 1;
          height: 40px;
          border-color: #dbe9f1;
          border-radius: 4px;
        }
        .uploading {
          position: absolute;
          left: 450px;
        }
      }

      .submitBtn {
        // width: 436px;
        width: 110px;
        // margin: 0 auto;
        margin-left: 340px;
        cursor: pointer;
        // margin-top: 33px;
        background: #409eff;
        box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.16);
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        text-align: center;
        color: #fff;
        line-height: 34px;
        &:hover {
          background: #66b1ff;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .regional-agent {
    .feature-cards {
      .feature-card {
        min-width: 100%;
      }
    }
  }
}
</style>

<style lang="less">
// 重置 Element Plus Message 组件样式
.el-message {
  font-size: 14px !important;
  line-height: 1.5 !important;
  padding: 10px 19px !important;

  .el-message__content {
    font-size: 14px !important;
    line-height: 1.5 !important;
  }

  .el-message__icon {
    font-size: 16px !important;
    margin-right: 10px !important;
  }
}
</style>
